import React from 'react';
import './results.css';
import { withTranslation } from 'react-i18next';
import configData from '../../../temp/config';

const Results = (props) => {

    // Extracting data fro props
    const { t, heightPredictorData, componentData } = props;
    let nothcUnit = sessionStorage.getItem('unit');
    // setting up scaleheight style
    let heightScale = '';
    let feetMaxHeightScale = '';
    let feetProbHeightScale = '';
    let feetMinHeightScale = '';

    // Gender taking from Api Response
    let gender = heightPredictorData.gender;
    // Here Dynamically replacing gender in the result title string
    let resultTitleStr = t('HeightPredictor_ResultTitle').replace('{gender}', gender);
    const resultTitle = { __html: resultTitleStr };

    // Here Dynamically replacing values in Result Description
    let bottom_resultDescStr = ''
    // let comma = `,`;
    let resultDescStr = ''
    if (nothcUnit === 'cm') {
        resultDescStr = t('HeightPredictor_ResultDescription') + ' ' + '<b>' + heightPredictorData.mostProbableHeight + ' ' + sessionStorage.getItem('unit') + '</b>';
        bottom_resultDescStr = t('HeightPredictor_BottomResultTitle').replace('{max}', '<b>' + heightPredictorData.maxProbableHeight + ' ' + sessionStorage.getItem('unit') + '</b>')
            .replace('{min}', '<b>' + heightPredictorData.minProbableHeight + ' ' + sessionStorage.getItem('unit') + '</b>')
        heightScale = {
            'counterReset': `notches ${heightPredictorData.maxScaleHeight + 5}`
        }
    } else {
        resultDescStr = `${t('HeightPredictor_ResultDescription')} <b> ${heightPredictorData.mostProbableHeight}'${heightPredictorData.mostProbableHeightInch} ${sessionStorage.getItem('unit')}</b>`;
        bottom_resultDescStr = t('HeightPredictor_BottomResultTitle').replace('{max}', '<b>' + heightPredictorData.maxProbableHeight + `${'\''}` + heightPredictorData.maxProbableHeightInch + ' ' + sessionStorage.getItem('unit') + '</b>')
            .replace('{min}', '<b>' + heightPredictorData.minProbableHeight + `${'\''}` + heightPredictorData.minProbableHeightInch + ' ' + sessionStorage.getItem('unit') + '</b>')
        heightScale = {
            'counterReset': `notches ${heightPredictorData.maxScaleHeight - 2}`
        }
    }



    const nothcUnitStr = {
        __html: nothcUnit
    }

    const resultDescription = {
        __html: resultDescStr
    }

    const bottom_ResultDescription = {
        __html: bottom_resultDescStr
    }

    const resultBackGroundColor = {
        backgroundColor: heightPredictorData.bgColorCodeHexa
    }

    // Cheking value is multilpe of 5 or not
    const checkHeightValue = (height) => {
        if (Number(height) % 5 === 0) return true
        return false;
    }

    const isMultipleof5 = checkHeightValue(heightPredictorData.maxProbableHeight);

    // if result height is multiple of 5 then start the scale from +5
    if (isMultipleof5) {
        heightScale = {
            'counterReset': `notches ${heightPredictorData.maxScaleHeight + 5}`
        }
    }



    let arr = [];
    let i = 0;
    const getScaleeArray = (maxScaleFeet, maxScaleHeightInch) => {
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        console.log(maxScaleHeightInch);
        if (maxScaleHeightInch === 0) {
            maxScaleHeightInch = 12
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = maxScaleHeightInch - 2;
            // console.log(maxScaleHeightInch);

        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }

        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        console.log(maxScaleHeightInch);
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
            // maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        console.log(maxScaleHeightInch);
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        // maxScaleHeightInch = maxScaleHeightInch - 2;
        if (maxScaleHeightInch === 0) {
            maxScaleFeet = maxScaleFeet - 1
            maxScaleHeightInch = 10
        }
        else {
            maxScaleHeightInch = maxScaleHeightInch - 2;
            console.log(maxScaleHeightInch);
        }
        arr.push(Number(maxScaleFeet + '' + maxScaleHeightInch))
        console.log(arr);
    }

    const scaleArray = getScaleeArray(heightPredictorData.maxScaleHeight, heightPredictorData.maxScaleHeightInch);
    console.log(scaleArray);

    const getString = (str) => {
        str = str.slice(0, 1) + "\'" + str.slice(1);
        return str
    }
    // if result height is multiple of 2 then start the scale from 2
    const checkFeetHeightValue = () => {
        var feetResult = `${heightPredictorData.maxProbableHeight}${heightPredictorData.maxProbableHeightInch}`;
        console.log(feetResult + "feet result");
        if (feetResult % 2 === 0) return true
        return false;
    }
    const isMultipleof2 = checkFeetHeightValue(heightPredictorData.maxProbableHeight);

    if (isMultipleof2) {
        feetMaxHeightScale = {
            'bottom': '160px'
        }
        feetProbHeightScale = {
            'background': heightPredictorData.labelColorPrimary,
            'bottom': '106px'
        }
        feetMinHeightScale = {
            'bottom': '60px'
        }
    }

    return (
        <div className="results" style={{ background: heightPredictorData.bgColorPrimary }}>
            <div className="heading" dangerouslySetInnerHTML={resultTitle} >
            </div>
            <div className="words" dangerouslySetInnerHTML={resultDescription}>
            </div>
            <div className="cols clearfix">

                <div className="graph">
                    {sessionStorage.getItem('unit') === 'cm' &&
                        <div className="cmWrapper">
                            <img className="scale-image" src={`${configData.sitecoreApiHost}${componentData.resultImage.value.src}`} alt="" />

                            <div className="cm-unit">
                                <div className="scale" style={heightScale}>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="notch"><span className="notch-unit-numbers"></span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    <div className="resultant-height-details">
                                        {isMultipleof5 && (<>
                                            <div className="marker max" style={{ 'bottom': '161px' }}>{heightPredictorData.maxProbableHeight} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker prob" style={{ 'bottom': '106px', 'background': heightPredictorData.labelColorPrimary }}>{heightPredictorData.mostProbableHeight} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker min" style={{ 'bottom': '61px' }}>{heightPredictorData.minProbableHeight} {sessionStorage.getItem('unit')}</div></>
                                        )}
                                        {!isMultipleof5 && (<><div className="marker max" style={{ 'bottom': '150px' }}>{heightPredictorData.maxProbableHeight} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker prob" style={{ 'bottom': '93px', 'background': '#007CB2', 'background': heightPredictorData.labelColorPrimary }}>{heightPredictorData.mostProbableHeight} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker min" style={{ 'bottom': '50px' }}>{heightPredictorData.minProbableHeight} {sessionStorage.getItem('unit')}</div></>)}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    {sessionStorage.getItem('unit') !== 'cm' &&
                        <div className="feetWrapper">
                            <img className="scale-image" src={`${configData.sitecoreApiHost}${componentData.resultImage.value.src}`} alt="" />

                            <div className="feet-unit">
                                <div className="scale">
                                    {arr.map((item, index) => {
                                        if (index < 8)
                                            return <div className="notch"><span className="notch-unit-numbers">{getString((item).toString())}</span><span className="notch-unit">{sessionStorage.getItem('unit')}</span></div>
                                    })}
                                    <div className="resultant-height-details">

                                        {isMultipleof2 && (<>
                                        <div className="feet-even-result">
                                            <div className="marker max" style={feetMaxHeightScale}>{heightPredictorData.maxProbableHeight}'{heightPredictorData.maxProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker prob" style={feetProbHeightScale}>{heightPredictorData.mostProbableHeight}'{heightPredictorData.mostProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker min" style={feetMinHeightScale}>{heightPredictorData.minProbableHeight}'{heightPredictorData.minProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                        
                                        </div>
                                        </>)}
                                        {!isMultipleof2 && (<>
                                        <div className="feet-odd-result">
                                            <div className="marker max" style={{ 'bottom': '147px' }}>{heightPredictorData.maxProbableHeight}'{heightPredictorData.maxProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker prob" style={{ 'bottom': '91px', 'background': '#007CB2', 'background': heightPredictorData.labelColorPrimary }}>{heightPredictorData.mostProbableHeight}'{heightPredictorData.mostProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                            <div className="marker min" style={{ 'bottom': '45px' }}>{heightPredictorData.minProbableHeight}'{heightPredictorData.minProbableHeightInch} {sessionStorage.getItem('unit')}</div>
                                        </div>
                                        </>)}
                                    </div>
                                </div>

                            </div>
                        </div>}

                </div>
            </div>
            <div className="words bottom-ribbon" dangerouslySetInnerHTML={bottom_ResultDescription} style={{ background: heightPredictorData.bgColorSecondary }}>
            </div>
        </div>
    )
}

export default withTranslation()(Results);